<template>
  <div class="main">
    <div class="list-bg">
      <img :src="bkimg" alt="">
    </div>
    <div class="contain">
      <div class="contain-title"><img src="../assets/contactUs-title.png" alt=""></div>
      <div class="contain-tabs">
        <div class="contain-tab">
          <div class="tab-logo-box">
            <img class="tab-logo" :src="base.phoneIcon" alt="">
          </div>
          <p>电话</p>
          <p>{{base.phoneNumber}}</p>
          <p>———</p>
        </div>
        <div class="contain-tab">
          <div class="tab-logo-box">
            <img class="tab-logo" :src="base.emailIcon" alt="">
          </div>
          <p>邮箱</p>
          <p>{{base.email}}</p>
          <p>———</p>
        </div>
        <div class="contain-tab">
          <div class="tab-logo-box">
            <img class="tab-logo" :src="base.addressIcon" alt="">
          </div>
          <p>地址</p>
          <p>{{base.address}}</p>
          <p>———</p>
        </div>
      </div>
      <div class="contain-map">
        <!-- <Map></Map> -->
        <img src="../assets/map.png" alt="">
      </div>
    </div>

  </div>
</template>
<script>
import Banner2 from '../views/Index/banner2'
import Map from '@/components/map/map'
import {getContactBase} from '@/api/contactUs.js'
// import {getthemelist} from '@/api/theme.js'
import bkimg from '../assets/contactUs-back.png'
export default {
  data () {
    return {
      lists: [],
      querylist: {
        page: 1,
        limit: 15
      },
      base: {},
      total: undefined,
      bkimg: bkimg
    }
  },
  components: {
    Banner2,
    Map
  },
  methods: {
    getContactBase () {
      getContactBase().then(res => {
        this.base = res.data.data
      })
    }

  },
  mounted () {

  },
  created () {
    this.getContactBase()
    if (this.$route.query.img) {
      this.bkimg = this.$route.query.img
    }
  }
}
</script>
<style scoped>
.main{
      background-color:#f4f4f4;
      padding-bottom:1.5rem;
  }
  .list-bg {
        width: 100%;
        height: 672px;
        /* background: url(../assets/contactUs-back.png) no-repeat center; */
        background-size: cover;
    }
  .list-bg img{
    width:100%;
    height: 672px;

  }
  .contain{
    width:80rem;
    background-color: #fff;
    padding-bottom:3.75rem;
    padding-top:59px;
    margin: -200px auto 0;
    position: relative;
  }
  .contain-title{
    width:1032px;
    margin:0 auto;
    margin-bottom:80px;
  }
  .contain-tabs{
    padding:0 196px;
    display:flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom:79px;
  }
  .contain-tab{
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width:33%;
  }
  .contain-tab p{
    margin-bottom:14px;
  }
  .contain-tab p:nth-child(2){
    font-size:16px;
    font-family:Source Han Sans CN;
    font-weight:300;
    color:rgba(44,48,51,1);
  }
  .contain-tab p:nth-child(3){
    font-size:14px;
    font-family:Source Han Sans CN;
    font-weight:300;
    color:rgba(0,128,204,1);
  }
  .contain-tab p:nth-child(4){
    color:rgba(0,128,204,1);
  }
  .tab-logo-box{
    width:146px;
    height:146px;
    border:1px dashed black;
    margin-bottom:22px;
  }
  .tab-logo{
    width:144px;
    height:144px;
  }
  .contain-map{
    padding:0 24px;
    box-sizing: border-box;
    width:100%;
    height:788px;
  }
</style>



// WEBPACK FOOTER //
// src/views/contactUs.vue